import { useSnackbar } from 'notistack';

/**
 * Displays an error alert using the notistack snackbar.
 */
const useErrorAlert = () => {
  const { enqueueSnackbar } = useSnackbar();

  /**
   * Displays an error alert using the notistack snackbar.
   *
   * @param {string} message - The error message to display in the alert.
   * @param {function} [handleClose] - Optional callback function to execute when the alert is closed.
   * The function receives two arguments: the event and the reason for closing.
   */
  const showErrorAlert = (message, handleClose) => {
    enqueueSnackbar(message, {
      variant: 'error',
      autoHideDuration: 3000,
      preventDuplicate: true,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      onClose: (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        if (handleClose) {
          handleClose(event, reason);
        }
      },
    });
  };

  return showErrorAlert;
};

export default useErrorAlert;
